import { render, staticRenderFns } from "./detail4.vue?vue&type=template&id=67dbde16&scoped=true"
import script from "./detail4.vue?vue&type=script&lang=js"
export * from "./detail4.vue?vue&type=script&lang=js"
import style0 from "./detail4.vue?vue&type=style&index=0&id=67dbde16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dbde16",
  null
  
)

export default component.exports